export default "__VITE_ASSET__DtGxBuvx__"